/**************************************************
 * Nombre:       PaginaLanding
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import fondo from '../Recursos/fondo.webp'
import logo from '../Recursos/logo_color.png'
import ic_location from '../Recursos/Iconos/ic_location.svg'
import ic_wass from '../Recursos/Iconos/ic_wass.svg'
import ic_check_verde from '../Recursos/Iconos/ic_check_verde.svg'
import ic_tienda from '../Recursos/Iconos/ic_tienda.svg'
import {LINKWASS, LOCALES, REDES} from "../Constantes";
import Tarjeta_Icono from "./Tarjetas/Tarjeta_Icono";
import Tarjeta_Boton from "./Tarjetas/Tarjeta_Boton";
import Indicador from "./Componentes/Indicador";
import Tarjeta_Tienda from "./Tarjetas/Tarjeta_Tienda";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../Utilidades/irUrl";
import {useEffect} from "react";
import {irArriba} from "../Utilidades/irArriba";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politica";

const PaginaLanding = () => {
    const {masSM} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})

    useEffect(() => {
        setTimeout(() => {
            irArriba()
        }, 50)

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#0D0202',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center top',


            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 8, md: 5}}
                sx={{
                    backgroundImage: `linear-gradient(179deg, rgba(11, 2, 2, 0.10) 33.58%, #0D0202 42.49%)`,
                    color: '#fff'
                }}

            >


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundImage: `url(${fondo})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        px: masSM ? 6 : 3

                    }}
                >


                    <Grid data-aos="fade-up" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <img src={logo} width={110} height={'auto'} alt={'Syc'}/>
                    </Grid>

                    <Grid data-aos="fade-up" data-aos-delay="300" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 22}}>
                        <Typography sx={{
                            fontSize: 20,
                            fontWeight: 900,
                            lineHeight: 1.4,
                            letterSpacing: 10,
                            fontFamily: 'Gibson'
                        }}>TIENDAS
                            <br/>DEPORTIVAS</Typography>
                    </Grid>

                    <Grid data-aos="fade-up" data-aos-delay="400" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 1,}}>
                        <Typography sx={{fontSize: 16, letterSpacing: 5}}>
                            <img src={ic_location} alt={'icono'} width={18} height={'auto'}
                                 style={{marginTop: 3, marginBottom: -3, marginRight: 8}}/>
                            Pasto - Ipiales
                        </Typography>

                    </Grid>

                    <Grid

                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                        sx={{mt: 2}}
                    >

                        {REDES.map((it, index) => {
                            return (
                                <IconButton
                                    onClick={() => irUrl(it.url)}
                                    sx={{px: 0}}
                                    data-aos="fade-left"
                                    data-aos-delay={(index + 1) * 300}>
                                    <img src={it.icono} width={52} height={'auto'} alt={'btn'}/>
                                </IconButton>
                            )
                        })}

                    </Grid>

                    <Grid data-aos="fade-up" data-aos-delay="800" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 3}}>
                        <Tarjeta_Icono titulo={'ATENCIÓN DIRECTA'} indicador={'CHAT WHATSAPP'} icono={ic_wass}
                                       texto={'+57 321 737 5018'} url={LINKWASS}/>
                    </Grid>

                    <Grid data-aos="fade-up" data-aos-delay="1000" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 3}}>
                        <Tarjeta_Icono titulo={'TIENDA VIRTUAL'} indicador={'CLICK EN ICONO'} icono={ic_tienda}
                                       texto={'www.syctiendadeportiva.com'} color={'#FF0101'} colorTexto={'#fff'}
                                       url={'https://syctiendadeportiva.com/'}/>
                    </Grid>

                    <Grid data-aos="fade-up" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 3}}>
                        <Tarjeta_Boton titulo={'COMUNIDAD VIP'} indicador={'OBTÉN BENEFICIOS'} icono={ic_check_verde}
                                       textoBoton={'HACER PARTE AHORA'}/>
                    </Grid>

                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{px: masSM ? 6 : 3, pb: 6}}
                >


                    <Grid data-aos="fade-up" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', mt: 4}}>
                        <Typography sx={{fontSize: 18, letterSpacing: 8, fontWeight: 900, fontFamily: 'Gibson'}}>
                            TIENDAS FISICAS
                        </Typography>
                    </Grid>

                    <Grid data-aos="fade-up" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Indicador texto={'PASTO'}/>
                    </Grid>

                    <Grid

                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: 4}}
                        spacing={4}
                    >

                        {LOCALES.map((it, index) => {
                            if (it.ciudad === 'pasto') {
                                return (
                                    <Grid data-aos="fade-right" container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Tienda item={it} derecha={index % 2}/>
                                    </Grid>
                                )
                            }
                        })}

                    </Grid>


                    <Grid data-aos="fade-up" container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Indicador texto={'IPIALES'} color={'#FF0000'} textoColor={'#fff'}/>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: 4}}
                        spacing={4}
                    >

                        {LOCALES.map((it, index) => {
                            if (it.ciudad === 'ipiales') {
                                return (
                                    <Grid data-aos="fade-right" container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Tienda item={it} derecha={index % 2}/>
                                    </Grid>
                                )
                            }
                        })}

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Button
                            onClick={() => abrir()}
                            fullWidth
                            sx={{
                                py: 1,
                                px: 3,
                                borderRadius: 8,
                                background: 'rgba(255, 255, 255, 0.20)',
                                color: '#fff',
                                fontSize: 14,
                                letterSpacing: 4,
                                fontWeight: 400
                            }}
                        >
                            POLÍTICAS DE PRIVACIDAD
                        </Button>
                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default PaginaLanding